<sc-flex [formGroup]="formGroup">

  <sc-checkbox-field formControlName="checked"
    [labelDictionaryKey]="supplementaryEquipment.dictionaryKey"></sc-checkbox-field>

  <ng-container *ngIf="supplementaryEquipment.parameter1Type != ParamterType.NONE">
    <sc-content-spacer></sc-content-spacer>
    <sc-number-field formControlName="parameter1" [labelDictionaryKey]="supplementaryEquipment.parameter1DictionaryKey"
      *ngIf="supplementaryEquipment.parameter1Type == ParamterType.NUMBER" required [disabled]="!selected"></sc-number-field>
    <sc-string-field formControlName="parameter1" [labelDictionaryKey]="supplementaryEquipment.parameter1DictionaryKey"
      *ngIf="supplementaryEquipment.parameter1Type == ParamterType.STRING" required [disabled]="!selected"></sc-string-field>
    <!-- TODO Identity-->
  </ng-container>

</sc-flex>
